import React from "react";
import TestImage from "../../components/Teachers/TestTracking/TestImage";
export default function TeacherTestImage() {
  return (
    <div>
      <TestImage />
    </div>
  );
}
